import axiosInstance from ".";

export const fetchPublicEvents = () =>
  axiosInstance.get(`/v1/events`);

export const fetchEvent = (id) =>
  axiosInstance.get(`/v1/events/${id}`);

export const fetchUserEvents = () =>
  axiosInstance.get(`/v1/events/dashboard`);

// Published, not-yet-happened events for the "more upcoming events" strip.
// "exclude" keeps the event being viewed out of its own list.
export const fetchUpcomingEvents = ({ exclude, limit } = {}) =>
  axiosInstance.get(`/v1/events/upcoming`, { params: { exclude, limit } });

export const registerForEvent = (id) =>
  axiosInstance.post(`/v1/events/${id}/register`);

export const cancelRegistration = (id) =>
  axiosInstance.delete(`/v1/events/${id}/register`);

export const fetchEventWinners = (id) =>
  axiosInstance.get(`/v1/events/${id}/winners`);
